import React, { useState } from 'react'
import { Button } from 'cantarus-react-ui'
import { FieldDataListStrings as Strings } from '../../../utils/config'
import SubListEntry from './SubListEntry'
import './styles.css'

const ListEntry = ({ entryKey, dataFields, dataFieldValues, onEditListEntry, onDeleteListEntry }) => {

    const baseClassName = 'td-list-entry'
    const noDataClassName = `${baseClassName}-no-data-text`

    const [expanded, toggleExpanded] = useState(false);

    const fieldValueIsValid = (field) => {
        const value = dataFieldValues[field.Name]

        if (field.Children.length <= 0 && (value instanceof Array)) {
            return false
        }
        else {
            return value ? true : typeof value === 'boolean'
        }
    }

    const trimAndDisplayValue = (value) => {
        if (typeof value === 'boolean') {
            return value ? 'True' : 'False';
        }
        else if (!value || value instanceof Array) {
            return Strings.noData;
        }
        else if (value.length < 200) {
            return value;
        }
        else {
            return `${value.substring(0, 200)}...`
        }
    }

    const renderDataFieldValue = (dataField) => {
        if (dataField.Children.length > 0) {
            return (
                <SubListEntry dataFields={dataField.Children} dataFieldValues={dataFieldValues ? dataFieldValues[dataField.Name] : []} />
            )
        }
        else {
            return (
                <span className={`${baseClassName}-data-field-value ${dataFieldValues && fieldValueIsValid(dataField) ? '' : noDataClassName} col-6`}>
                    {dataFieldValues ? trimAndDisplayValue(dataFieldValues[dataField.Name]) : Strings.noData}
                </span>
            )
        }

    }

    const onToggleListEntry = () => {
        toggleExpanded(!expanded)
    }

    return (
        <div className={expanded ? `${baseClassName}-wrapper row` : `${baseClassName}-wrapper row ${baseClassName}--collapsed`}>
            <div className={`${baseClassName}-index`}>{entryKey + 1}</div>
            <div className={`${baseClassName}-data-wrapper col-11 container`}>
                <div className={`${baseClassName}-header row`}>
                    <span className={`${baseClassName}-data-field-name col-6`}>{Strings.listEntryNameHeader}</span>
                    <span className={`${baseClassName}-data-field-value col-6`}>{Strings.listEntryValueHeader}</span>
                </div>
                {dataFields.map((dataField) =>
                    <div className={`${baseClassName}-data row`}>
                        <hr className={`${baseClassName}-rule`} />
                        <span className={`${baseClassName}-data-field-name col-6`}>{dataField.FriendlyName || dataField.Name}</span>
                        {renderDataFieldValue(dataField)}
                    </div>
                )}
            </div>
            {onEditListEntry && onDeleteListEntry
                && <div className={`${baseClassName}-actions`}>
                    <Button classes={['icon', 'edit']} title={Strings.editEntry} onClick={onEditListEntry} />
                    <Button classes={['icon', 'delete']} title={Strings.deleteEntry} onClick={onDeleteListEntry} />
                    <Button classes={['icon', 'collapse']} title={Strings.collapseEntry} onClick={onToggleListEntry} />
                    <Button classes={['icon', 'expand']} title={Strings.expandEntry} onClick={onToggleListEntry} />
                </div>
            }
        </div>

    );

};

export default ListEntry;
